import {GAN_SUPPLIERS as PREFIX} from '../const';
import {
    GAN_SUPPLIERS_COMMON_LIST_API,
    GAN_SUPPLIERS_LIST_API,
} from '../const/apiMethods';

import {createAction} from './defaults';
import {api} from "../api/loginRoutes";
import {servicePick, getServiceSmsPrefix} from "../utils/helpers";


const setGanSuppliersList = createAction('SET_ITEMS_' + PREFIX);
const clearGanSuppliersListAction = createAction('CLEAR_ITEMS_' + PREFIX);
const setGanSuppliersCommonList = createAction('SET_ITEMS_COMMON_' + PREFIX);
const setLoading = createAction('SET_LOADING_' + PREFIX);

let latestGanSuppliersListRequestId = 0;
let latestGanSuppliersCommonListRequestId = 0;

export const clearGanSuppliersList = () => (dispatch) => {
    latestGanSuppliersListRequestId += 1;
    dispatch(clearGanSuppliersListAction());
};

export const getGanSuppliersList = (filter) => (dispatch) => {
    const requestId = ++latestGanSuppliersListRequestId;

    const params = {filter};

    dispatch( setLoading(true) );
    return api(GAN_SUPPLIERS_LIST_API, params)
        .then((r) => {
            if (requestId !== latestGanSuppliersListRequestId) {
                return;
            }

            if (r === undefined || !r.supplier_list) {
                return;
            }

            dispatch( setGanSuppliersList({
                list: r.supplier_list,
            }) );
        })
        .finally(() => {
            if (requestId === latestGanSuppliersListRequestId) {
                dispatch( setLoading(false) );
            }
        });
};


export const getGanSuppliersCommonList = (service, filter) => (dispatch) => {
    const requestId = ++latestGanSuppliersCommonListRequestId;

    const params = {filter};

    dispatch( setLoading(true) );
    const method = getServiceSmsPrefix(service, GAN_SUPPLIERS_COMMON_LIST_API);

    return api(method, params)
        .then((r) => {
            if (requestId !== latestGanSuppliersCommonListRequestId) {
                return;
            }

            const checkKey = servicePick(service, "supplier_list", "sms.supplier_list");

            if (r === undefined || !r[checkKey]) {
                return;
            }

            dispatch( setGanSuppliersCommonList({
                list: r[checkKey],
            }) );
        })
        .finally(() => {
            if (requestId === latestGanSuppliersCommonListRequestId) {
                dispatch( setLoading(false) );
            }
        });
};
